import { AppBar, Box, Button, CssBaseline, Grid, Tab, Tabs, Typography, useTheme } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import LabelsContext from "../../../../lang/LabelsContext";
import EnumReviewStatus from "../../../../utils/enum/EnumReviewStatus";
import { getReviewStatus } from "../../../../utils/Utils";
import ArticleCard from "../../article-card/ArticleCard";
import ArticleRevisionService, { ArticleRevisionServiceType } from "./ArticleRevisionService";
import useStyles from "./ArticleRevisionStyle";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}
const TAB_CORRECTION = 2;

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function ArticleRevision() {
  const classes = useStyles();
  const history = useHistory();
  const { Labels } = LabelsContext();
  const theme = useTheme();
  const { minorList, majorList, correctionList, tabSelected, handleChangeTab }: ArticleRevisionServiceType =
    ArticleRevisionService();

  const rightButtons = (article: any) => {
    const { status, id } = article;
    return (
      <Grid container spacing={1}>
        {tabSelected !== TAB_CORRECTION && (
          <Grid item>
            <Button variant="contained" size="small" onClick={() => history.push(`/uploadRevision/${id}`)}>
              {Labels.UPLOAD_REVISION}
            </Button>
          </Grid>
        )}
        {status === EnumReviewStatus.CORRECTION && tabSelected === TAB_CORRECTION && (
          <Grid item>
            <Button variant="contained" size="small" onClick={() => history.push(`/correction/${id}`)}>
              {Labels.ADJUST_MANUSCRIPT}
            </Button>
          </Grid>
        )}
      </Grid>
    );
  };

  const renderArticle = (list: any) => (
    <Grid container direction="row" xs={12} sm={12}>
      {list?.map((article: any, index: number) => (
        <Grid item xs={12} sm={12}>
          <ArticleCard
            data={article}
            index={index}
            rightComponent={() => rightButtons(article)}
            linkDisable={true}
            showReviewsDialog={true}
          />
        </Grid>
      ))}
    </Grid>
  );

  return (
    <>
      <CssBaseline />
      {minorList?.lenth === 0 && majorList?.lenth === 0 && correctionList?.lenth === 0 && (
        <Grid>
          <Typography gutterBottom variant="h5" component="h2">
            No article for revision
          </Typography>
        </Grid>
      )}
      <div className={classes.container}>
        <Typography component="span" variant="h5">
          Action needed
        </Typography>
        <AppBar position="static" color="default" className={classes.appBar}>
          <Tabs
            value={tabSelected}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label={getReviewStatus(EnumReviewStatus.MINOR_REVISION, Labels)} {...a11yProps(0)} />
            <Tab label={getReviewStatus(EnumReviewStatus.MAJOR_REVISION, Labels)} {...a11yProps(1)} />
            <Tab label={getReviewStatus(EnumReviewStatus.CORRECTION, Labels)} {...a11yProps(2)} />
          </Tabs>
        </AppBar>
        <TabPanel value={tabSelected} index={0} dir={theme.direction}>
          {renderArticle(minorList)}
        </TabPanel>
        <TabPanel value={tabSelected} index={1} dir={theme.direction}>
          {renderArticle(majorList)}
        </TabPanel>
        <TabPanel value={tabSelected} index={2} dir={theme.direction}>
          {renderArticle(correctionList)}
        </TabPanel>
      </div>
    </>
  );
}
